// Compacte legenda voor de heatmap-overlay. Zelfde kleurschaal als
// Map2D's "heatmap-cells"-laag (kleurenblind-vriendelijk: blauw-geel-rood).

import { useStore } from "../state/store";
import { InfoBadge } from "./ui/InfoBadge";

const STOPS = [
  { f: 0, color: "#2c7bb6" },
  { f: 0.25, color: "#abd9e9" },
  { f: 0.5, color: "#ffffbf" },
  { f: 0.75, color: "#fdae61" },
  { f: 1, color: "#d7191c" },
];

export function HeatmapLegend() {
  const visible = useStore((s) => s.heatmapVisible);
  const hasResult = useStore((s) => s.yearResult !== null);
  if (!visible || !hasResult) return null;

  const gradient = `linear-gradient(to right, ${STOPS.map(
    (s) => `${s.color} ${s.f * 100}%`,
  ).join(", ")})`;

  return (
    <div className="absolute right-4 bottom-16 z-20 bg-card/95 backdrop-blur border border-border rounded-md shadow px-3 py-2 text-xs">
      <div className="font-medium mb-1 flex items-center gap-1">
        Schaduw per jaar
        <InfoBadge text="Per cel het percentage daglichturen dat in schaduw valt over een heel jaar (15-minuten-samples, 0,5 m grid). Blauw = veel zon, rood = veel schaduw. Kleurenblind-vriendelijke schaal." />
      </div>
      <div className="h-2 w-44 rounded-sm" style={{ background: gradient }} />
      <div className="flex justify-between mt-1 text-muted-foreground">
        <span>0%</span>
        <span>50%</span>
        <span>100%</span>
      </div>
    </div>
  );
}
